__turbopack_context__.v({
  "actionParamsContainer": "timeline-node-manager-module__ppe3Ka__actionParamsContainer",
  "addButton": "timeline-node-manager-module__ppe3Ka__addButton",
  "conditionNode": "timeline-node-manager-module__ppe3Ka__conditionNode",
  "dark": "timeline-node-manager-module__ppe3Ka__dark",
  "darkEdge": "timeline-node-manager-module__ppe3Ka__darkEdge",
  "errorBlock": "timeline-node-manager-module__ppe3Ka__errorBlock",
  "errorText": "timeline-node-manager-module__ppe3Ka__errorText",
  "headerSideDrawer": "timeline-node-manager-module__ppe3Ka__headerSideDrawer",
  "highlightedEdge": "timeline-node-manager-module__ppe3Ka__highlightedEdge",
  "input": "timeline-node-manager-module__ppe3Ka__input",
  "label": "timeline-node-manager-module__ppe3Ka__label",
  "lightEdge": "timeline-node-manager-module__ppe3Ka__lightEdge",
  "loadingBlock": "timeline-node-manager-module__ppe3Ka__loadingBlock",
  "loadingOverlay": "timeline-node-manager-module__ppe3Ka__loadingOverlay",
  "modelIcon": "timeline-node-manager-module__ppe3Ka__modelIcon",
  "modelPreview": "timeline-node-manager-module__ppe3Ka__modelPreview",
  "modelPreviewContainer": "timeline-node-manager-module__ppe3Ka__modelPreviewContainer",
  "modelPreviewLoading": "timeline-node-manager-module__ppe3Ka__modelPreviewLoading",
  "noTimelineBlock": "timeline-node-manager-module__ppe3Ka__noTimelineBlock",
  "noTimelineButton": "timeline-node-manager-module__ppe3Ka__noTimelineButton",
  "noTimelineText": "timeline-node-manager-module__ppe3Ka__noTimelineText",
  "noTimelineTitle": "timeline-node-manager-module__ppe3Ka__noTimelineTitle",
  "nodeContainer": "timeline-node-manager-module__ppe3Ka__nodeContainer",
  "nodeEvent": "timeline-node-manager-module__ppe3Ka__nodeEvent",
  "nodeHeader": "timeline-node-manager-module__ppe3Ka__nodeHeader",
  "nodeLabel": "timeline-node-manager-module__ppe3Ka__nodeLabel",
  "nodeLabelHr": "timeline-node-manager-module__ppe3Ka__nodeLabelHr",
  "nodeSubtitle": "timeline-node-manager-module__ppe3Ka__nodeSubtitle",
  "nodeTitle": "timeline-node-manager-module__ppe3Ka__nodeTitle",
  "nodesConstructorControls": "timeline-node-manager-module__ppe3Ka__nodesConstructorControls",
  "nodesConstructorWrapper": "timeline-node-manager-module__ppe3Ka__nodesConstructorWrapper",
  "previewActionButton": "timeline-node-manager-module__ppe3Ka__previewActionButton",
  "questBlockWrapper": "timeline-node-manager-module__ppe3Ka__questBlockWrapper",
  "questParams": "timeline-node-manager-module__ppe3Ka__questParams",
  "selected": "timeline-node-manager-module__ppe3Ka__selected",
  "selectedEdge": "timeline-node-manager-module__ppe3Ka__selectedEdge",
  "sideDrawer": "timeline-node-manager-module__ppe3Ka__sideDrawer",
  "targetId": "timeline-node-manager-module__ppe3Ka__targetId",
  "targetNode": "timeline-node-manager-module__ppe3Ka__targetNode",
  "targetPreviewContainer": "timeline-node-manager-module__ppe3Ka__targetPreviewContainer",
  "targetPreviewImage": "timeline-node-manager-module__ppe3Ka__targetPreviewImage",
  "timelineContainer": "timeline-node-manager-module__ppe3Ka__timelineContainer",
  "timelineTitle": "timeline-node-manager-module__ppe3Ka__timelineTitle",
});
